import React, { useEffect } from 'react';

import { useSearchParams, useNavigate } from 'react-router-dom';

import application from 'application';
import serverInterface from 'server-interface';

import internalEventCodes from 'event-system/codes/internal';

import './index.scss';

function GoogleCalendarIntegration(props) {

  const [searchParameters] = useSearchParams();
  const navigate = useNavigate();

  useEffect(function onLoad() {

    tryIntegrate();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function tryIntegrate() {

    const result = await serverInterface.currentUser.tryConnectToGoogleCalendar({
      code: searchParameters.get('code')
    });

    const origin = decodeURIComponent(searchParameters.get('origin'));
    const url = new URL(origin);

    const navigationParameters = {
      pathname: url.pathname
    };

    if (result !== null) {
      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Connected to Google Calendar',
        seconds: 5,
        type: 'info'
      });
      navigationParameters.search = '?' + url.searchParams.toString();
    } else {
      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Failed to connect to Google Calendar',
        seconds: 5,
        type: 'error'
      });
    }

    navigate(navigationParameters);

  }

  function renderMain() {

    return <div id="google-calendar-integration-main">
      <ht-spinner />
    </div>;

  }

  return renderMain();

}

export default GoogleCalendarIntegration;